export default "__VITE_ASSET__80e3551d__"